import { useTranslation } from 'react-i18next';
import { Checkbox } from '@digdir/designsystemet-react';
import React, { FC } from 'react';
import { FieldPathByValue, useFormContext } from 'react-hook-form';

import { DetaljeringForm } from '../types';

interface Props {
  name: FieldPathByValue<DetaljeringForm, boolean>;
  disabled?: boolean;
  onChange?: () => void;
}

export const DetailingCheckbox: FC<Props> = ({ name, onChange, disabled }) => {
  const { t } = useTranslation('', { keyPrefix: 'form.valgfriDetaljering.detaljeringSelection.options' });
  const { register, watch } = useFormContext<DetaljeringForm>();

  const isChecked = watch(name);

  return (
    <Checkbox
      {...register(name, { onChange: onChange, shouldUnregister: true })}
      label={t(`${name}.title`)}
      description={isChecked && t(`${name}.description`)}
      disabled={disabled}
    />
  );
};
